import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_generate_report_btn = _resolveComponent("generate-report-btn")!
  const _component_reports_table = _resolveComponent("reports-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_generate_report_btn, {
      client: _ctx.client,
      color: "primary",
      rounded: "",
      onGenerated: _ctx.prepend
    }, null, 8, ["client", "onGenerated"]),
    _createVNode(_component_reports_table, {
      "client-id": _ctx.client.id,
      ref: "reports"
    }, null, 8, ["client-id"])
  ]))
}